import i18n from "../../../plugins/i18n.js";
import router from "../../../router";
import store from "../../../store";
import {
  readFromLocalStorage,
  saveToLocalStorage,
} from "./localStorageHandler";

export const setLanguage = (locale, forceReRoute) => {
  if (forceReRoute == null) forceReRoute = true;

  i18n.locale = locale;
  store.commit("UPDATE_RTL", locale === "ar");

  if (forceReRoute) {
    router.push({
      params: { lang: locale },
    });
  }

  return locale;
};

export const getSavedLanguage = () => {
  return readFromLocalStorage("Language");
};

export const saveLanguage = value => {
  saveToLocalStorage("Language", value);
};

export const customLocalisedAutoCompleteFilter = (item, queryText) => {
  if (!queryText) return true;
  const q = String(queryText).toLowerCase().trim();
  const words = q.split(/\s+/).filter(Boolean);
  const texts = [];

  if (typeof item === "object" && item !== null) {
    if (item.name) {
      if (Array.isArray(item.name)) {
        item.name.forEach(x => { if (x?.value) texts.push(String(x.value).toLowerCase()); });
      } else {
        texts.push(String(item.name).toLowerCase());
      }
    }
    if (item.title) {
      if (Array.isArray(item.title)) {
        item.title.forEach(x => { if (x?.value) texts.push(String(x.value).toLowerCase()); });
      } else {
        texts.push(String(item.title).toLowerCase());
      }
    }
    if (item.email) texts.push(String(item.email).toLowerCase());
    if (item.civilIdOrPassport) texts.push(String(item.civilIdOrPassport).toLowerCase());
    if (item.user) {
      if (item.user.firstName) texts.push(String(item.user.firstName).toLowerCase());
      if (item.user.lastName) texts.push(String(item.user.lastName).toLowerCase());
      if (item.user.email) texts.push(String(item.user.email).toLowerCase());
      if (item.user.civilIdOrPassport) texts.push(String(item.user.civilIdOrPassport).toLowerCase());
    }
  } else if (typeof item === "string") {
    texts.push(item.toLowerCase());
  }

  const combined = texts.join(" ");
  if (combined.includes(q)) return true;
  return words.length > 0 && words.every(w => combined.includes(w));
};
